import type { RegistrationType } from '@form-factory/schema';
import { DateFormat, formatUtils } from '@form-factory/shared';
import { useLingui } from '@lingui/react/macro';
import { createColumnHelper } from '@tanstack/react-table';
import { useMemo } from 'react';

const columnHelper = createColumnHelper<RegistrationType>();

export function useRegistrationsCols() {
  const { t } = useLingui();

  return useMemo(
    () => [
      columnHelper.accessor(row => row.email, {
        id: 'email',
        header: t`Email`,
        meta: {
          sortable: 'email',
        },
      }),
      columnHelper.accessor(row => row.firstName, {
        id: 'firstName',
        header: t`First name`,
        meta: {
          sortable: 'firstName',
        },
      }),
      columnHelper.accessor(row => row.membershipName, {
        id: 'membershipName',
        header: t`Membership`,
        meta: {
          sortable: 'membershipName',
        },
      }),
      columnHelper.accessor(row => row.clubId, {
        id: 'clubId',
        header: t`Club`,
        meta: {
          sortable: 'clubId',
        },
      }),
      columnHelper.accessor(row => row.createdAt, {
        id: 'createdAt',
        header: t`Created at`,
        cell: row => formatUtils.date(row.getValue(), DateFormat.DateTime),
        meta: {
          sortable: 'createdAt',
        },
      }),
    ],
    [t],
  );
}
